// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer vierkant {
  v-user-list > * {
    margin-right: 1rem;
  }
  v-user-list :last-child {
    margin-right: 0 !important;
  }
  v-user-list .gc-user-list-element .drag-handle {
    margin-top: 3px;
  }
  v-user-list .gc-user-list-element .p-chip {
    gap: 0.5rem;
  }
  v-user-list .gc-user-list-element.hasDrag {
    cursor: grab;
  }
  v-user-list .gc-user-list-element.cdk-drag-placeholder {
    opacity: 0;
  }
  v-user-list .gc-user-list-element.cdk-drag-animating {
    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
  }
  v-user-list .gc-user-list-element.cdk-drop-list-dragging v-user-list .gc-user-list-element:not(.cdk-drag-placeholder) {
    transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
  }
  v-user-list p-chip {
    height: 32px !important;
    padding-right: 0.5rem !important;
  }
  v-user-list > p-chip {
    --p-chip-padding-y: 0;
  }
  v-user-list .v-user {
    align-items: flex-start;
    height: 32px;
    margin-left: calc(-1 * var(--p-chip-padding-x, 1rem));
  }
  v-user-list .v-user span {
    height: 32px !important;
    line-height: 32px !important;
    text-wrap-mode: nowrap !important;
  }
  v-user-list > * {
    margin-right: 1rem;
  }
  v-user-list :last-child {
    margin-right: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/v-user-list/v-user-list.component.sass"],"names":[],"mappings":"AAAA;EAEQ;IACI,kBAAA;EAAV;EACM;IACI,0BAAA;EACV;EAIU;IACI,eAAA;EAFd;EAGU;IACI,WAAA;EADd;EAEU;IACI,YAAA;EAAd;EACU;IACI,UAAA;EACd;EAAU;IACI,sDAAA;EAEd;EADU;IACI,sDAAA;EAGd;EAFM;IAEI,uBAAA;IACA,gCAAA;EAGV;EAFM;IACI,qBAAA;EAIV;EAHM;IACI,uBAAA;IACA,YAAA;IACA,qDAAA;EAKV;EAJU;IACI,uBAAA;IACA,4BAAA;IACA,iCAAA;EAMd;EALM;IACI,kBAAA;EAOV;EANM;IACI,0BAAA;EAQV;AACF","sourcesContent":["@layer vierkant\n    v-user-list\n        > *\n            margin-right: 1rem\n        :last-child\n            margin-right: 0 !important\n\n        .user-chip v-user\n            // margin-left: -12px\n        .gc-user-list-element\n            .drag-handle\n                margin-top: 3px\n            .p-chip\n                gap: 0.5rem\n            &.hasDrag\n                cursor: grab\n            &.cdk-drag-placeholder\n                opacity: 0\n            &.cdk-drag-animating\n                transition: transform 250ms cubic-bezier(0, 0, 0.2, 1)\n            &.cdk-drop-list-dragging &:not(.cdk-drag-placeholder) \n                transition: transform 250ms cubic-bezier(0, 0, 0.2, 1)\n        p-chip\n            // padding: 0 !important\n            height: 32px !important\n            padding-right: 0.5rem !important\n        > p-chip \n            --p-chip-padding-y: 0\n        .v-user\n            align-items: flex-start\n            height: 32px\n            margin-left: calc(-1 * var(--p-chip-padding-x, 1rem))\n            span\n                height: 32px !important\n                line-height: 32px !important\n                text-wrap-mode: nowrap !important\n        > *\n            margin-right: 1rem\n        :last-child\n            margin-right: 0 !important\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
